import './NoGroups.scss'

export default function NoGroups() {
	return (
		<div className="nogroups">
			<p>Нет групп</p>
		</div>
	)
}